const validateForm = (formData, individual, customMessage = false) => {
  const errors = {};
  let isValid = true;
  if (individual === "Individual" || individual === "IndividualCobuyer") {
    // First Name validation
    if (!formData.firstName?.trim()) {
      errors.firstName = customMessage
        ? "Invalid Name"
        : "First name is required";
    } else if (!/^[A-Za-z0-9\s]{1,30}$/.test(formData.firstName)) {
      errors.firstName =
        "First name should contain only letters, numbers, and spaces (2-30 characters long)";
    }
    // Last Name validation
    if (!formData.lastName?.trim()) {
      errors.lastName = customMessage
        ? "Invalid Name"
        : "Last name is required";
    } else if (!/^[A-Za-z0-9\s]{1,30}$/.test(formData.lastName)) {
      errors.lastName =
        "Last name should contain only letters, numbers, and spaces (2-30 characters long)";
    }
    // Email validation
    if (!formData.emailId?.trim()) {
      errors.emailId = customMessage ? "Invalid Email" : "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      errors.emailId = "Please enter a valid email address";
    }

    // Address validation
    if (!formData.address1?.trim()) {
      errors.address1 = customMessage
        ? "Invalid Individual Address"
        : "Address is required";
    } else if (formData.address1.length < 1) {
      errors.address1 = "Address should be at least 5 characters long";
    }

    // State validation
    if (!formData.state) {
      errors.state = customMessage ? "Please select a state" : "State is required";
    }

    // City validation
    if (!formData.city) {
      errors.city = customMessage ? "Invalid City" : "City is required";
    }

    // Zipcode validation
    if (!formData.zip) {
      errors.zip = customMessage ? "Invalid Zip Code" : "Zip Code is required";
    } else if (!/^\d{5}(-\d{4})?$/.test(formData.zip)) {
      errors.zip = "Please enter a valid zip code (e.g., 12345 or 12345-6789)";
    }
    // Phone number validation
    if (!formData.phoneNumber) {
      errors.phoneNumber = customMessage
        ? "Invalid Phone Number"
        : "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber.replace(/\D/g, ""))) {
      errors.phoneNumber = "Please enter a valid 10-digit phone number";
    }
  } else if (
    individual === "Business Entity" ||
    individual === "BusinessEntityCobuyer"
  ) {
    // First Name validation
    if (!formData.firstName?.trim()) {
      errors.firstName = customMessage
        ? "Invalid Name"
        : "First name is required";
    } else if (!/^[A-Za-z0-9\s]{1,30}$/.test(formData.firstName)) {
      errors.firstName =
        "First name should contain only letters, numbers, and spaces (2-30 characters long)";
    }

    // Last Name validation
    if (!formData.lastName?.trim()) {
      errors.lastName = customMessage
        ? "Invalid Name"
        : "Last name is required";
    } else if (!/^[A-Za-z0-9\s]{1,30}$/.test(formData.lastName)) {
      errors.lastName =
        "Last name should contain only letters, numbers, and spaces (2-30 characters long)";
    }

    // Middle Name validation is optional, but if provided, validate format
    if (
      formData.middleName &&
      !/^[A-Za-z\s]{0,30}$/.test(formData.middleName)
    ) {
      errors.middleName =
        "Middle name should contain only letters and be up to 30 characters long";
      isValid = false;
    }

    // Corporation Name validation
    if (!formData.corporationName?.trim()) {
      errors.corporationName = customMessage
        ? "Invalid Corporation Name"
        : "Corporation name is required";
      isValid = false;
    } else if (formData.corporationName.length < 2) {
      errors.corporationName =
        "Corporation name should be at least 2 characters long";
      isValid = false;
    }

    // Corporation Address validation
    if (!formData.address1?.trim()) {
      errors.address1 = customMessage
        ? "Invalid Corporation Address"
        : "Corporation address is required";
      isValid = false;
    } else if (formData.address1.length < 1) {
      errors.address1 = "Address should be at least 5 characters long";
      isValid = false;
    }

    // State validation
    if (!formData.state) {
      errors.state = customMessage ? "Please select a state" : "State is required";
      isValid = false;
    }

    // City validation
    if (!formData.city) {
      errors.city = customMessage ? "Invalid City" : "City is required";
      isValid = false;
    }

    // Zipcode validation
    if (!formData.zip) {
      errors.zip = customMessage ? "Invalid Zip Code" : "Zip code is required";
      isValid = false;
    } else if (!/^\d{5}(-\d{4})?$/.test(formData.zip)) {
      errors.zip = "Please enter a valid zip code (e.g., 12345 or 12345-6789)";
      isValid = false;
    }

    // Email validation
    if (!formData.emailId?.trim()) {
      errors.emailId = customMessage
      ? "Invalid Email"
      : "Email is required";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      errors.emailId = "Please enter a valid email address";
      isValid = false;
    }

    // Phone number validation
    if (!formData.phoneNumber) {
      errors.phoneNumber =customMessage
      ? "Invalid Phone  Number"
      :  "Phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phoneNumber.replace(/\D/g, ""))) {
      errors.phoneNumber = "Please enter a valid 10-digit phone number";
      isValid = false;
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
export default validateForm;
